import React, { memo } from "react";
import { MxInputControllerProps } from "../../l1/form/MxInputController";
import MxFieldControllerContext from "../../../context/MxFieldController";

interface MxFormInputControllerProps extends MxInputControllerProps {
  name: string;
  children: React.ReactNode;
  // Prefer boolean; legacy numeric kept for compatibility
  withReactHookForm?: boolean;
  withreacthookform?: 1 | 0;
}
const MxFormFieldController = memo((props: MxFormInputControllerProps) => {
  return <MxFieldControllerContext {...props} />;
});

export default MxFormFieldController;
